import { render, staticRenderFns } from "./ElementABCDPlanTableColumn.vue?vue&type=template&id=035f4692&scoped=true"
import script from "./ElementABCDPlanTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementABCDPlanTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementABCDPlanTableColumn.vue?vue&type=style&index=0&id=035f4692&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f4692",
  null
  
)

export default component.exports